export default __webpack_public_path__ + "static/media/image.5001e05a.svg";